import { render, staticRenderFns } from "./CreateApiScopeDlg.vue?vue&type=template&id=2a8024bd&"
import script from "./CreateApiScopeDlg.vue?vue&type=script&lang=js&"
export * from "./CreateApiScopeDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports